export default [
  {
    path: "/penyakit-hewan/",
    component: () => import("@/pages/penyakit-hewan/penyakit-hewan-list.vue"),
    meta: { title: "Daftar Penyakit Hewan" },
  },
  {
    path: "/penyakit-hewan/create",
    component: () => import("@/pages/penyakit-hewan/penyakit-hewan-form.vue"),
    meta: { title: "Tambah Penyakit Hewan" },
  },
  {
    path: "/penyakit-hewan/detail/:id",
    component: () => import("@/pages/penyakit-hewan/penyakit-hewan-detail.vue"),
    meta: { title: "Detail Penyakit Hewan" },
  },
  {
    path: "/penyakit-hewan/update/:id",
    component: () => import("@/pages/penyakit-hewan/penyakit-hewan-edit.vue"),
    meta: { title: "Edit Penyakit Hewan" },
  },
];
